"use client";
import React from "react";
import { Text, Button, EmptyState } from "@thenounproject/lingo-core";
import * as Sentry from "@sentry/nextjs";
// import { settings } from "shared";

interface ErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

const env = process.env.NODE_ENV || "development";

export default function GlobalError({ error, reset }: ErrorProps) {
  React.useEffect(() => {
    // Log the error to your error reporting service
    console.error("Global error caught:", error);

    // Report to Sentry if configured
    if (typeof window !== "undefined") {
      Sentry.captureException(error);
    }
  }, [error]);

  return (
    <html lang="en">
      <head>
        <link rel="icon" href="/favicon/favicon2023.png" />
        <script
          dangerouslySetInnerHTML={{
            __html: `window._lingoEnvironment = "${env}";`,
          }}
        />
      </head>
      <body>
        <EmptyState
          title="Something went wrong"
          subtitle="We're having some problems on our end. We'll get it fixed as soon as we can."
          iconProps={{ iconId: "error", size: "80", fill: "error" }}
          button={{
            text: "Try again",
            onClick: reset,
          }}
          extra={
            <Text font="ui.small" color="grayDarker" mt="l">
              If the problem persists, please{" "}
              <Button
                text="contact us"
                buttonStyle="tertiary"
                size="small"
                link="mailto:info@lingoapp.com"
              />
            </Text>
          }
        />
      </body>
    </html>
  );
}
